import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createMenuNavigation, readRoute } from "../lib/menuNavigation.js";
import { createScreenState, screenOwner } from "../lib/screenState.js";
export function useMenuNavigation(isBlocked, identity) {
  const [route, setRoute] = useState(() => readRoute(globalThis.location));
  const controller = useRef(null), blocked = useRef(isBlocked);
  blocked.current = isBlocked;
  const owner = screenOwner(identity);
  const screenState = useMemo(() => {
    const [userId, academyId, role] = owner.split(":");
    return createScreenState(globalThis.window, { userId, academyId, role },
      readRoute(globalThis.location));
  }, [owner]);
  useEffect(() => {
    const disconnect = screenState.connect();
    const navigation = createMenuNavigation(globalThis.window, {
      onChange: (_, next) => { screenState.transition(next); setRoute(next); },
      blocked: () => blocked.current(),
    });
    controller.current = navigation;
    return () => {
      navigation.dispose();
      disconnect();
      controller.current = null;
    };
  }, [screenState]);
  const navigate = useCallback(
    (next) => controller.current?.navigate(next),
    [],
  );
  const open = useCallback(
    (kind, id, month) => controller.current?.open(kind, id, month),
    [],
  );
  const close = useCallback(() => controller.current?.close(), []);
  const openPanel = useCallback(
    (panel, entry) => controller.current?.openPanel(panel, entry),
    [],
  );
  const boundScreenState = useMemo(() => screenState.bind(route), [screenState, route]);
  return [route.view, navigate, { route, open, close, openPanel, screenState: boundScreenState }];
}
